module.exports = __webpack_public_path__ + "img/diyCardTitle.feb878b4.png";